import { RocheUIBadgeColor as E } from "../../badge/roche-badge.types.js";
var A = /* @__PURE__ */ ((l) => (l.NEAR_PATIENT_CARE = "near-patient-care", l.PATHOLOGY_LAB = "pathology-lab", l.DIGITAL_SOLUTION = "digital-solution", l.CORE_LAB = "core-lab", l.MOLECULAR_LAB = "molecular-lab", l.DIAGNOSTICS_INSIGHTS = "diagnostics-insights", l.HEALTHCARE_INSIGHTS = "healthcare-insights", l.OTHER = "other", l))(A || {});
const L = {
  "near-patient-care": E.EXTRA_LIGHT_BLUE,
  "pathology-lab": E.LIGHT_BLUE,
  "digital-solution": E.NAVY,
  "core-lab": E.NAVY,
  "molecular-lab": E.ROCHE_BLUE,
  "diagnostics-insights": E.DARK_GREEN,
  "healthcare-insights": E.BRIGHT_GREEN,
  other: E.GREY
};
export {
  A as RocheUIDiagnosticsItemVariant,
  L as rocheUIDiagnosticsItemVariantBadgeColor
};
